import { IRccapAdditionalQuestionWithValidation } from "@nkr/models/index";

export interface ICancelSwap {
    chainId: string,
    clusterNumber: string,
    positionNumber: string,

    donorId: number,
    donorAlias: string,
    donorCenterAlias: string,
    donorCenterId: number,
    remoteDonorCenterAlias: string,
    remoteDonorCenterId: number,

    recipientId: number,
    recipientAlias: string,
    recipientAbo: string,
    recipientPmpC: string,
    recipientCpra: string,
    pairedDonorAbo: string,
    recipientCenterAlias: string,
    recipientCenterId: number,

    responsibleCenter: number,
    requester: number,
    failDate: string,
    nkrLiaison: number,
    dueDate: string,

    transplantsImpacted: number,

    matchOfferDate: string,

    exmRequestedDate: string,
    rccapPhase: number,

    issueDescription: string,
    issueDescriptionValid: boolean,
    additionalQuestions: IRccapAdditionalQuestionWithValidation[]
    rootCausePrimary: number,
    rootCauseSecondary: number,
    rccapAvoidable: number,
    rccapBillable: number,
    rccapSatisfactoryResponse: number,
    acceptedResponse: string,
    correctiveActionPrimary: number,
    correctiveActionSecondary: number,
    centerCorrectiveAction: string,
    responder: string,
    responseDate: string,
    dataRetrieved: boolean
}